"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBrandDetails = exports.DEFAULT_POSE_OPTIONS = void 0;
var defaultDemoGameSettings_json_1 = __importDefault(require("./defaultDemoGameSettings.json"));
exports.DEFAULT_POSE_OPTIONS = [
    "Geek",
    "Angry baby",
    "Crab claws",
    "Cat face",
    "Shake face",
    "Duck face",
    "Balloon face",
    "Rage face",
    "Ecstatic",
    "Ecstasy",
    "Evil",
    "Cheese",
    "Rabbit in headlights",
    "Love",
    "Fake laugh",
    "Muscles",
    "Beard stroke",
    "Home alone",
    "Peace",
    "Swimming",
    "Glamorous",
    "Skydiving",
];
var defaultBrandDetails = function (_a) {
    var brandId = _a.brandId, domain = _a.domain, name = _a.name;
    return {
        id: brandId,
        domain: domain || "pose.party",
        // Settings
        name: name || "Pose.Party",
        title: "",
        description: "",
        headerShadow: true,
        footerShadow: true,
        showHomepageJoinGameForm: true,
        allPlayersMustSignIn: false,
        allPlayersAreHosts: false,
        allowSignUp: false,
        allowedSignUpEmailDomains: [],
        allowCustomGameId: false,
        allowDemoGames: false,
        allowInPersonGames: false,
        requireEmailForDemoGames: true,
        demoGameSettings: defaultDemoGameSettings_json_1.default,
        allowHostPerGameSettings: false,
        allowJoinLate: false,
        hostGameLimit: 10,
        gamePoseLimit: 5,
        gamesHaveRandomPoses: false,
        gamePoseOptions: exports.DEFAULT_POSE_OPTIONS,
        stillSnapshots: false,
        allowGameBranding: false,
        allowProtectedGalleries: true,
        hideNamesInGalleries: false,
        hideFinishedGamesInAccount: false,
        allowTournaments: false,
        allowSpectators: false,
        allowLockedGames: false,
        allowLargeGames: false,
        allowHostGameUI: false,
        allowWebcamInScreenshareUI: false,
        allowEndingGameEarly: false,
        allowAddingNewRoundsInGame: false,
        allowSwapCamera: false,
        allowSnapshotWebcam: true,
        allowSnapshotUpload: false,
        defaultToUserFacingCamera: true,
        enableCameraTimer: false,
        deleteGamesWhenFinished: false,
        emailGameArchiveWhenFinished: false,
        gameArchiveExpiryDays: 7,
        allowPerPoseTiming: false,
        hideRoundCountdown: false,
        timingRoundStartInterstitial: 5 * 1000,
        timingPoseRoundLength: 30 * 1000,
        timingScoreHintInterstitial: 5 * 1000,
        timingRoundEndInterstitial: 2 * 1000,
        timingResultsOwnScoreInterstitial: 5 * 1000,
        maxPlayerNameLength: 20,
        // Colors
        colors: {
            primaryBrand: "#4AE4DB",
            primaryBrandOverlay: "#000000",
            secondaryBrand: "#000000",
            secondaryBrandOverlay: "#FFFFFF",
            background: "#F3F5F8",
            backgroundOverlay: "#000000",
            headerBackground: "#FFFFFF",
            headerBackgroundOverlay: "#000000",
            footerBackground: "#FFFFFF",
            footerBackgroundOverlay: "#000000",
            textInputBackground: "#FFFFFF",
            textInputBackgroundOverlay: "#000000",
            desktopBackground: "#FFFFFF",
            galleryBackground: "#F3F5F8",
            galleryBackgroundOverlay: "#000000",
        },
        // Backgrounds
        headerBackgroundImage: null,
        contentBackgroundImage: null,
        footerBackgroundImage: null,
        galleryBackgroundImage: null,
        desktopBackgroundImage: null,
        // Game buttons
        gameButtonImageCapture: null,
        gameButtonImageAccept: null,
        gameButtonImageReject: null,
        gameButtonImageSwapCamera: null,
        gameButtonDislike: null,
        gameButtonLike: null,
        gameButtonSuperLike: null,
        gameScoringDislike: null,
        gameScoringLike: null,
        gameScoringSuperLike: null,
        // Overlay
        videoOverlay: null,
        slideshowOverlay: null,
        // Overlay pose text
        videoOverlayPoseFontFile: null,
        videoOverlayPoseFontSize: null,
        videoOverlayPoseFontAlignment: null,
        videoOverlayPoseFontColor: null,
        videoOverlayPosePositionX: null,
        videoOverlayPosePositionY: null,
        videoOverlayPoseTextFormat: null,
        // Logo
        logo: null,
        icon: null,
        showLogoInHeader: false,
        previewImage: null,
        // Email template
        emailFromAddress: "play@poseparty.com",
        emailTemplateGallery: null,
        emailTemplateImage: null,
        emailGameArchive: null,
        emailTemplateUserWelcome: null,
        emailTemplateDemoGameGallery: null,
        emailDemoGameAlertAddress: "play@poseparty.com",
        emailDemoGameAlertTemplate: "new-demo",
        emailUserDemoStartTemplate: "new-demo-user",
        emailTournamentCreateTemplate: null,
        // Landing page content
        landingPageContent: {
            homepage: {
                top: "",
                middle: "",
                bottom: "",
            },
            auth: {
                signUp: "",
                login: "",
                forgottenPassword: "",
            },
            tournament: {
                top: "",
                heats: "Click the heat that you are part of to join the game. The winner from each heat will progress to the final.",
                final: "The winner from each heat will progress to the final. If you won your heat you will take part in the game, and if not you can spectate and vote for your favourite snapshots.",
                bottom: "",
            },
            gamePlayer: {
                top: "",
                bottom: "",
            },
            gameHost: {
                top: "",
                bottom: "",
            },
            gameDemo: {
                top: "",
                bottom: "",
            },
            gameInPerson: {
                top: "",
                bottom: "",
            },
            gameUnsupported: {
                top: "",
                bottom: "",
            },
            userAccount: {
                top: "",
                middle: "",
                bottom: "",
            },
            gallery: {
                gridTop: "",
                gridBottom: "",
                shareTop: "",
                shareBottom: "",
            },
            slideshow: {
                shareTop: "",
                shareBottom: "",
            },
            demoGame: {
                top: "",
                bottom: "",
            },
            startInPersonGame: {
                top: "",
                bottom: "",
            },
        },
        demoHelpContent: {
            preSetup: "",
            preProfilePhoto: "",
            prePose: "",
            preScore: "",
            preResults: "",
            preFinalResults: "",
        },
    };
};
exports.defaultBrandDetails = defaultBrandDetails;
//# sourceMappingURL=Brand.js.map